import { get } from '@core/js/utils/fetch.util';

import { parseQueryString } from '@interlayer/js/app/utils/parseQueryString.util';
import { TGamesGlobalJackpot, TGetEyeconJackpotsResponse } from '@interlayer/js/components/common/Jackpot/buzz/types';

export const getEyeconJackpots = ({
    dTagEyeconJackpotUrl,
    currencyCode
}: {
    dTagEyeconJackpotUrl: string;
    currencyCode: string;
}): Promise<TGetEyeconJackpotsResponse> => {
    return get(`${dTagEyeconJackpotUrl}?${parseQueryString({ currencyCode })}`);
};

export const getGamesGlobalJackpots = ({
    dTagGamesGlobalJackpotUrl,
    currencyCode,
    moduleId
}: {
    dTagGamesGlobalJackpotUrl: string;
    currencyCode?: string;
    moduleId?: string | number;
}): Promise<TGamesGlobalJackpot[]> => {
    return get(`${dTagGamesGlobalJackpotUrl}?${parseQueryString({
        ...currencyCode && { currencyIsoCode: currencyCode },
        ...moduleId && { moduleId }
    })}`);
};
